import React, { ReactNode } from 'react'
import * as S from './styles'
import { Icon, Tooltip } from 'components'
import { TooltipProps } from '@mui/material'
import { DivProps } from 'commons/types/htmlElements'
import { theme } from 'styles/theme/hav-theme'

export interface InfoProps extends DivProps {
  children: ReactNode | string
  iconSize?: number
  placement?: TooltipProps['placement']
}

export const Info: React.FC<InfoProps> = ({
  children,
  iconSize = 20,
  placement = 'top',
  ...rest
}) => {
  return (
    <S.InfoContainer {...rest}>
      <Tooltip
        disableFocusListener
        placement={placement}
        arrow
        title={<S.InfoContent>{children}</S.InfoContent>}
      >
        <S.IconContainer>
          <Icon icon="info" color={theme.colors.primary.main} size={`${iconSize}`} />
        </S.IconContainer>
      </Tooltip>
    </S.InfoContainer>
  )
}
